import React, { useState, useEffect } from "react";
import Select from "react-select";

import { Search } from 'lucide-react';
import classes from "./MonthlyRemitance.module.css"
import { toast, ToastContainer } from 'react-toastify';
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form,Row,Col} from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from 'sweetalert2';
import { useLocation } from "react-router-dom";







const MonthlyRemitance = () => {
  const [selectedOption, setSelectedOption] = useState(null);
   const [allAccounts, setAllAccounts] = useState([]);
   const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
     const [selectedBank, setSelectedBank] = useState('');
     const [balanceLoading, setBalanceLoading] = useState(false);
       const [income, setIncome] = useState([]);
   const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
    const [error, setError] = useState(null);
   const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [tableData, setTableData] = useState([]);
   const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [accounts, setAccounts] = useState([]);
    // const [balances, setBalances] = useState([]);
  const [totalAmountCredit, setTotalAmountCredit] = useState('');
  const [totalAmountDebit, setTotalAmountDebit] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [description, setDescription] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [selectedDebitAccount, setSelectedDebitAccount] = useState(null);
  const [debit1, setDebit1] = useState([]);
      const [incomeLoading, setIncomeLoading] = useState(false);
  const [foundRemitance,setFoundRemitance] = useState([]);
  const [totalCredit, setTotalCredit] = useState(0);
  const [incomeAmount, setIncomeAmount] = useState('');
   const [currentMonth, setCurrentMonth] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [ledgTableData, setLedgTableData] = useState([]);
 const [load, setLoad] = useState(false);
  const handleOpenModal = () => setShowModal(true);
   const [isEqual, setIsEqual] = useState(false);
  const handleCloseModal = () => setShowModal(false);
    const [selectedImage, setSelectedImage] = useState('');
      const [createLoading, setCreateLoading] = useState('');
         const location = useLocation();
  // const balances = location.state?.balances;
  const [balances, setBalances] = useState(location.state?.balances || []);
         const [provinceID, setProvinceID] = useState('');
  const [formData, setFormData] = useState([]);
  //      const [formData, setFormData] = useState(() => {
  //     return (
  //         foundRemitance?.items?.map((item, index) => ({
  //             sn: index + 1,
  //             accountName: item.item?.id,
  //             accountCode: item.item?.gl_code,
  //             amount: item.amount,
  //         })) || []
  //     );
  // });

   const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
       const current = await localStorage.getItem('currentMonth');


      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
        if (current !== null) {
        console.log(current);
        const date = new Date(current);
      
        setCurrentMonth(date);
      
        const startOfDateRange = new Date(1900, 0, 1);
     
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const day = String(date.getDate()).padStart(2, '0');     
          return `${year}-${month}-${day}`;
        };
      
        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      
        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

   const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


    const handleShow1 = () => setShow1(true);
  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
        const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
        const results = response.data?.data?.data;
        const resultx = response.data?.data?.total;
        setTotalEntries(resultx);
        setTableData(results);
        console.log(results, "From Remittane")
        const total = response.data?.data?.last_page || 1;
        setTotalPages(total);
      
    } catch (error) {
        if (error.response && error.response.status === 401) {
            navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response?.data && error.response?.data.message) {
              if (typeof error.response?.data.message === 'string') {
                  errorMessage = error.response?.data.message;
              } else if (Array.isArray(error.response?.data.message)) {
                  errorMessage = error.response?.data.message.join('; ');
              } else if (typeof error.response?.data.message === 'object') {
                console.log(errorMessage);
                setError(errorMessage)
              }
          }
            setTableData([]);
        }
    } finally {
        setBenLoading(false);
    }
    
  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);
    useEffect(() => {

    setIsEqual(totalAmountDebit === totalAmountCredit);
  }, [totalAmountDebit, totalAmountCredit]);
//  const uploadStatement = async () => {
//     setCreateLoading(true);

//     try {

//       const formData = new FormData();
//       formData.append('file', selectedImage);
//       formData.append('transaction_date', selectedDate);


//       const response = await axios.post(
//         `${BASE_URL}/upload-monthly-remittance`,
//         formData,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//             'Authorization': `Bearer ${bearer}`
//           }
//         }
//       );

//       console.log(response, "heeee");
//       setBalances(response.data.data);
//       handleClose();
      
//       setSelectedImage("");
//       Swal.fire({
//         icon: 'success',
//         title: 'Successful',
//         text: response.data.message,
//       });
      
//     } catch (error) {
//       let errorMessage = 'An error occurred. Please try again.';
//       if (error.response && error.response.data && error.response.data.message) {
//         if (typeof error.response.data.message === 'string') {
//           errorMessage = error.response.data.message;
//         } else if (Array.isArray(error.response.data.message)) {
//           errorMessage = error.response.data.message.join('; ');
//         } else if (typeof error.response.data.message === 'object') {
//           errorMessage = JSON.stringify(error.response.data.message);
//         }
//         Swal.fire({
//           icon: 'error',
//           title: 'Failed',
//           text: JSON.stringify(error.response.data.message),
//         });
//       }
//       console.error(error);
//     } finally {
//       setCreateLoading(false);
//     }
//   };



      const fetchAccountss = async () => {
        console.log(headers)
        setLoadings(true);

        try {
            const response = await axios.get(`${BASE_URL}/account`, { headers });

            const CustomOption = (props) => {
              const { data, innerRef, innerProps } = props;
              return (
                <div ref={innerRef} {...innerProps}>
                  <span style={{ color: 'blue' }}>{data?.gl_code}</span>
                  {' - '}
                  <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
                </div>
              );
            };

            const allAccts = response.data?.data;
            const opt1 = allAccts.map((item) => ({
                label: `${item.gl_code} - ${item.gl_name}`,
                value: item.id,
            }));
            setAllAccounts(opt1);

            //   console.log(allAccts, "All Accounts");
        } catch (error) {
            const errorStatus = error.response?.data.message;
            console.error(errorStatus);
        } finally {
            setLoadings(false);
        }
    };

 useEffect(() => {
    if (bearer) {
        fetchAccountss();
    }
}, [bearer]);


function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

   const calculateTotalDebit = () => {
    const total1 = balances.reduce((acc, item) => {
      return item.amount ? acc + parseFloat(item.amount || 0) : acc;
    }, 0);

    const formattedTotal11 = total1.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountDebit(formattedTotal11);
  };

  useEffect(() => {
  
      calculateTotalDebit();

  }, [balances]);

    const calculateTotalCredit = () => {
    const total1 = balances.reduce((acc, item) => {
      return item.amount ? acc + parseFloat(item.amount || 0) : acc;
    }, 0);

    const formattedTotal11 = total1.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountCredit(formattedTotal11);
  };

    useEffect(() => {
  
    calculateTotalCredit();

  }, [balances]);

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };
  
  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

const formattedTotalEntries = totalEntries.toLocaleString();

 const fetchStat = async () => {
    setStatLoading(true);
    try {
        const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
        const stas = response.data?.data;
       
        setStat(stas);
     
    } catch (error) {
        if (error.response && error.response.status === 401) {
            navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                console.log(errorMessage);
              }
          }
            setStat([]);
        }
    } finally {
        setStatLoading(false);
    }
};

useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

 
const fetchDebit1 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/get-loans-receivables`, { headers });

      const debt1 = response.data?.data;
      const oopt1 = debt1.map((item) => ({
        label: item.gl_name,
        value: item.id,


      }));
      setDebit1(oopt1);



    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchDebit1();
    }
  }, [bearer]);
  const formatStat = (value) => {
  if (value == null) return "";

  if (value >= 1000 && value < 1000000) {
    const rounded = value / 1000;
    // If divisible by 1000 exactly, no decimals (30k)
    if (value % 1000 === 0) {
      return `${rounded}k`;
    }
    // Else show 2 decimals (30.01k)
    return `${rounded.toFixed(2)}k`;
  }

  if (value >= 1000000) {
    const rounded = value / 1000000;
    if (value % 1000000 === 0) {
      return `${rounded}M`;
    }
    return `${rounded.toFixed(2)}M`;
  }

  // smaller than 1000 → just locale string with commas
  return value.toLocaleString("en-US");
};

const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
 const handleDateChange1 = (event) => {
        setSelectedEndDate(event.target.value);
    };

 const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    const createIncome = async () => {
    setIncomeLoading(true);

    try {
        const accountNames = formData.map((row) => row.accountName).filter((name) => name !== undefined);
        const amounts = formData.map((row) => row.amount).filter((amount) => amount !== undefined);
        const payload = {
          id: foundRemitance?.id,
            account_id: accountNames,
            debit_gl: selectedDebitAccount?.value || '',
            description: description,
            customer_id: selectedCustomer?.value || '',
            // payment_mode: selectedPayment,
            amount: amounts,
            total_credit: totalCredit,
            total_debit: incomeAmount,
            // teller_no: teller,
            // particulars: receive,
            // currency: selectedCurrency,
            transaction_date: selectedDate,
            // bank_id: selectedBanks
        };

        console.log("Payload:", payload);

        const response = await axios.post(`${BASE_URL}/update-remittance`, payload, { headers });

        console.log(response.data, "Response Data");
        navigate(-1);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });

        // toast.success(response.data.message);
    } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
              // toast.error(errorMessage);
            }
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: JSON.stringify(error.response.data.message),
            });
        }
    } finally {
        setIncomeLoading(false);
    }
};

   const fetchReceipt = async () => {
        setLoad(true);
        try {
            const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
            const results = response.data?.data?.data;
            const resultx = response.data?.data?.total;
            setLedgTableData(results);
            const total = response.data?.data?.last_page || 1;
            setTotalPages(total);
            console.log("fetched Receipts:", results);
            // toast.success(response.data.message);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                navigate('/login');
            } else {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    if (typeof error.response.data.message === 'string') {
                        errorMessage = error.response.data.message;
                    } else if (Array.isArray(error.response.data.message)) {
                        errorMessage = error.response.data.message.join('; ');
                    } else if (typeof error.response.data.message === 'object') {
                        toast.error(errorMessage)
                        console.log(errorMessage);
                    }
                }
                setTableData([]);
            }
        } finally {
            setLoad(false);
        }
    };



    useEffect(() => {
        if (bearer) {
            fetchReceipt();

        }
    }, [bearer, currentPage]);

  const postBalances = async () => {
    setBalanceLoading(true);
    const accountNames = balances.map((row) => row.account_name).filter((name) => name !== undefined);
    const accountCodes = balances.map((row) => row.account_code).filter((name) => name !== undefined);
    const debits = balances.map((row) => row.debit).filter((name) => name !== undefined);
    const credits = balances.map((row) => row.credit).filter((name) => name !== undefined);

    console.log(accountNames, accountCodes, debits, credits, totalAmountCredit, totalAmountDebit)
    try {
      //  return;
      const response = await axios.post(
        `${BASE_URL}/save-monthly-remittance`,
        {
          total_debit: parseFloat(totalAmountDebit.replace(/,/g, '')),
          total_credit: parseFloat(totalAmountCredit.replace(/,/g, '')),
          debit_gl: selectedDebitAccount,
          uuid: balances[0]?.uuid,
          transaction_date: selectedDate



        },
        { headers }
      );


      console.log(response.data?.message, "heeee");
      setBalances([]);
      setSelectedDate('');
      setSelectedDebitAccount('');
      setTotalAmountCredit('');
      setTotalAmountDebit('');
      setSelectedDebitAccount(null);
handleClose1();
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });

      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        console.log(error);
      }
    } finally {
      setBalanceLoading(false);
    }
  };


    useEffect(() => {

        calculateTotalCredit();
    }, [formData]);


 const handleBank = (selectedOption) => {
        setSelectedBank(selectedOption.value);
    };
  const handleValueChange1 = (value, index) => {
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            amount: value,
        };
        setFormData(updatedFormData);
        calculateTotalCredit(); // Recalculate total credit whenever table amounts change
    };
    const goBack = () => {
        navigate(-1);
    }

     const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

     const handleAccountChange = (index, event) => {
        const selectedAccount = event.target.value;
        const intselectedId = parseInt(selectedAccount);
        const selectedGlCode = income.find((item) => item.id === intselectedId)?.gl_code || '';

        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            accountName: selectedAccount,
            accountCode: selectedGlCode,
        };

        setFormData(updatedFormData);
    };

    const handleCreate = () => {

    }
       const addRow = () => {
        const newRow = {
            sn: formData.length + 1,
            accountName: '',
            accountCode: '',
            amount: ''
        };
        setFormData([...formData, newRow]);
        // setSelectedPayment('');
    };

    const deleteRow = (index) => {
        const updatedData = formData.filter((_, i) => i !== index);
        setFormData(updatedData);
    };

     const handleValueChange = (value) => {
        setIncomeAmount(value);
    };

   useEffect(() => {
  if (foundRemitance?.items) {
    const mapped = foundRemitance.items.map((item, index) => ({
      sn: index + 1,
      accountName: item.item?.id,
      accountCode: item.item?.gl_code,
      amount: item.amount,
    }));
    setFormData(mapped);
  }
  if (foundRemitance?.transaction_date) {
    setSelectedDate(foundRemitance.transaction_date);
  }
   if (foundRemitance?.description) {
    setDescription(foundRemitance.description);
  }
   if (foundRemitance?.amount) {
    setIncomeAmount(foundRemitance.amount);
  }

  if (foundRemitance?.debit_account) {
    setSelectedDebitAccount(foundRemitance.debit_account.id);
  }
}, [foundRemitance]);

const handlePrint = (id) => {
  handleOpenModal();
  const selectedLedger = ledgTableData.find(item => item.id === id);
  setFoundRemitance(selectedLedger);
  console.log(selectedLedger); // use this instead of FormData
};

 const handleTrashClick = async (id) => {
      const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You are about to delete this remittance.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel',
      });
  
      if (!confirmed.isConfirmed) {
        return; // User canceled, do nothing
      }
  
      try {
        const response = await axios.get(`${BASE_URL}/delete-remittance?id=${id}`, { headers });
        fetchReceipt();
        Swal.fire({
          icon: 'success',
          title: 'Successful',
          text: response.data.message,
        });
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: JSON.stringify(error.response.data.message),
          });
          console.log(errorMessage);
        }
      }
    };


    const handleCustomerChange = (selectedOption) => {
      setSelectedCustomer(selectedOption.value);
    };

     const handleAssetChange = (selectedOption) => {
        setSelectedDebitAccount(selectedOption.value);
    };
  return (
     <div >
     <Modal
      show={showModal}
      onHide={handleCloseModal}
      size="xl"
      centered
      backdrop="static"
    >
      {/* Header */}
      <Modal.Header closeButton>
        <Modal.Title>Update Remittance</Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body>
        <Form>
          {/* Row 1: Customer + Transaction Date */}
          <div className="row">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Customer
                </Form.Label>
                <Select
                  value={selectedCustomer}
                  isLoading={loading}
                  options={customerList}
                  placeholder="Select Customer"
                  onChange={setSelectedCustomer}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Transaction Date
                </Form.Label>
                <Form.Control
                  className={classes.formControl}
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  min={minDate}
                  max={maxDate}
                />
              </Form.Group>
            </div>
          </div>

          {/* Row 2: Description */}
          <div className="row mt-3">
            <div className="col-12">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  name="description"
                />
              </Form.Group>
            </div>
          </div>

          {/* Row 3: Debit Account + Amount */}
          <div className="row mt-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Debit Account
                </Form.Label>
                <Select
                  value={selectedDebitAccount}
                  isLoading={loading}
                  onChange={setSelectedDebitAccount}
                  options={debit1}
                  placeholder="Select Debit GL"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label className={classes.formLabelCustom}>
                  Amount
                </Form.Label>
                <CurrencyInput
                  name="amount"
                  decimalsLimit={2}
                  className="form-control"
                  value={incomeAmount}
                  onValueChange={handleValueChange}
                  style={{ textAlign: "right" }}
                />
              </Form.Group>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive mt-4">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light text-center">
                <tr>
                  <th>#</th>
                  <th style={{ width: "40%" }}>Account Name</th>
                  <th>Account Code</th>
                  <th>Amount</th>
                  <th>
                    <Button style={{borderRadiu: 80}} variant="primary" onClick={addRow}>
                      <i className="fas fa-plus"></i>
                    </Button>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {formData?.map((row, index) => (
                  <tr key={index}>
                    <td>{row.sn}</td>
                    <td>
                      <Form.Select
                        value={row.accountName}
                        onChange={(e) => handleAccountChange(index, e)}
                      >
                        <option value="">Select Account</option>
                        {income.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.gl_name}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        value={row.accountCode}
                        readOnly
                        disabled
                      />
                    </td>
                    <td>
                      <CurrencyInput
                        name={`rowAmount-${index}`}
                        value={row.amount}
                        className="form-control"
                        onValueChange={(value) =>
                          handleValueChange1(value, index)
                        }
                        style={{ textAlign: "right" }}
                      />
                    </td>
                    <td>
                      <Button
                        
                        variant="danger"
                        onClick={() => deleteRow(index)}
                      >
                      <i className="fas fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="row mt-4">
            <div className="col-md-6 offset-md-6">
              <div className="d-flex justify-content-between">
                <Form.Group className="me-3">
                  <Form.Label>Total Debit</Form.Label>
                  <CurrencyInput
                    name="totalDebit"
                    decimalsLimit={2}
                    className="form-control"
                    value={incomeAmount}
                    disabled
                    style={{ textAlign: "right" }}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Total Credit</Form.Label>
                  <CurrencyInput
                    name="totalCredit"
                    decimalsLimit={2}
                    className="form-control"
                    value={totalCredit}
                    disabled
                    style={{ textAlign: "right" }}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </Form>
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button
          variant="success"
          disabled={parseFloat(incomeAmount) !== parseFloat(totalCredit)}
          onClick={createIncome}
        >
          {incomeLoading ? (
            <>
              <Spinner size="sm" />
              <span className="ms-2">Processing...</span>
            </>
          ) : (
            "Update Remittance"
          )}
        </Button>
      </Modal.Footer>
    </Modal>



                               {/* <Modal show={show1} onHide={handleClose1} animation={false}>
                              <Modal.Header closeButton>
                                <Modal.Title className="h6">Save Monthly Remitance</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <Form style={{ marginTop: 20 }}>
                                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <div style={{ marginTop: 10 }} />
                                    <Form.Label>Transaction Date:</Form.Label>
                                    <Form.Control
                                      type="date"
                                      onChange={handleDateChange}
                                      value={selectedDate}
                                      min={minDate}
                                      max={maxDate}
                                    />
                                    <div style={{ marginTop: 10 }} />
                                    <Form.Label>Debit GL:</Form.Label>
                                    <Select

                                      loading={loading}
                                      onChange={(selectedOption) => handleAssetChange(selectedOption)}
                                      options={debit1}
                                      placeholder='Select Debit GL'
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: '300px',
                                          maxWidth: '700px',
                                          overflowY: 'auto',
                                        }),
                                      }}
                                    />
                                    
                                  </Form.Group>
                                </Form>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button variant="light" onClick={handleClose1}>
                                  Go back
                                </Button>
                                <Button variant="success" onClick={postBalances} className={classes.loanBtn}>
                                  {balanceLoading ? (
                                    <>
                                      <Spinner size='sm' />
                                      <span style={{ marginLeft: '5px' }}>Saving, Please wait...</span>
                                    </>
                                  ) : (
                                    "Save"
                                  )}
                                </Button>
                              </Modal.Footer>
                            </Modal> */}
                             <Modal show={show1} onHide={handleClose1} animation={false}>
                              <Modal.Header closeButton>
                                <Modal.Title className="h6">Save Monthly Remitance</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <Form style={{ marginTop: 20 }}>
                                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <div style={{ marginTop: 10 }} />
                                    <Form.Label>Transaction Date:</Form.Label>
                                    <Form.Control
                                      type="date"
                                      onChange={handleDateChange}
                                      value={selectedDate}
                                      min={minDate}
                                      max={maxDate}
                                    />
                                    <div style={{ marginTop: 10 }} />
                                    <Form.Label>Debit GL:</Form.Label>
                                    <Select

                                      loading={loading}
                                      onChange={(selectedOption) => handleAssetChange(selectedOption)}
                                      options={debit1}
                                      placeholder='Select Debit GL'
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: '300px',
                                          maxWidth: '700px',
                                          overflowY: 'auto',
                                        }),
                                      }}
                                    />
                                    
                                  </Form.Group>
                                </Form>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button variant="light" onClick={handleClose1}>
                                  Go back
                                </Button>
                                <Button variant="success" className={classes.loanBtn} onClick={postBalances}>
                                  {balanceLoading ? (
                                    <>
                                      <Spinner size='sm' />
                                      <span style={{ marginLeft: '5px' }}>Saving, Please wait...</span>
                                    </>
                                  ) : (
                                    "Saves"
                                  )}
                                </Button>
                              </Modal.Footer>
                            </Modal>


      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Monthly Remitance Upload</h3>
        <p className={classes.prgText}>Upload, View, and Save Monthly Remitances.</p>
          {/* <Row style={{ marginTop: 16 }}>
  <Col md={3}>
    <div className={classes.thrdkad}>
      <p className={classes.kdptg}>Total Monthly Uploads</p>
      <p className={classes.kdptg1}>₦8,400,000.00</p>
      <div className={classes.rvnue}>
        <p className={classes.skaltxt}>Uploaded for this month</p>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.frtkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Processed Uploads</p>
        <p className={classes.kdptg2}>₦4,950,000.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Successfully processed uploads</p>
        </div>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.fiftkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Validated Uploads</p>
        <p className={classes.kdptg3}>₦3,200,000.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Validated and confirmed uploads</p>
        </div>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.frstkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Pending Uploads</p>
        <p className={classes.kdptg4}>₦3,200,000.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Awaiting review/processing</p>
        </div>
      </div>
    </div>
  </Col>
</Row> */}

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>Customer</th>
                <th>Account</th>
                <th style={{ textAlign: "right",paddingRight:20  }}>Amount</th>
              </tr>
            </thead>
           <tbody>
 {
  balances.map((item, index) => (
      <tr key={index}>
        <td className={classes.textby}> {item.customer_name}</td>
         <td  className={classes.textby}>
                                            {item.description}
                                          </td>
        <td style={{ textAlign: "right",paddingRight:20 }} className={classes.textby}>
          {parseFloat(item.amount).toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        </td>
       
      </tr>
    ))
 }
</tbody>


          </table>
          <div style={{ marginTop: 20 }} />
                            <div className={classes.form_align}>
                              <Form.Group className="mb-3">
                                <Form.Label>Total Debit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={totalAmountDebit}
                                  name="total"
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>Total Credit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={totalAmountCredit}
                                  name="total"
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                            </div>


                            <div class={`modal-footer ${classes.overlaybtn100}`} style={{ marginTop: '20px', paddingRight: '20px' }}>
                              <Button
                                className={classes.longbtn}
                                variant='success'
                                onClick={handleShow1}
                                disabled={!isEqual}
                                style={{ padding: '5px 30px' }}>
                                Save
                              </Button>
                            </div>
          {/* {!isSearching && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )} */}


        </div>
      </div>
      {loading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
      {uploading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  )
}

export default MonthlyRemitance;